import './dashboard.css';
import MerckTMDashboard from './MerckTMDashboard/merck-tm-dashboard';
import SuppliersDashboard from './SuppliersDashboard/suppliers-dashboard';
import NoAccess from '../../no-access';
import { getUserRole } from '../../components/Shared/utils';

const Dashboard: React.FC = () => {
  const userRole = getUserRole();

  if (!userRole) {
    return <NoAccess />;
  }

  const role = userRole.toLowerCase();

  if (role === "supplier" || role === "merck_supplier") {
    return <SuppliersDashboard accessRole={userRole} />;
  }

  if (role === "requester" || role === "admin") {
    return <MerckTMDashboard accessRole={userRole} />;
  }

  return <NoAccess />;
};

export default Dashboard;
